<template>
<div class="chapter">
<div class="inner_page">
<p class="block_10" id="calibre_pb_3"> </p>
<p class="block_9"> </p>
<p class="block_9"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_3"> </p>
<p class="block_11" id="id_Hlk154603642">Tepa tasi: (to) look over something (often an event, point in history, a memory) to recollect, to remember once more.</p>
<p class="block_3"> </p>
<p class="block_11">Le Au’alumā: a group of women, often related, who are the soul of a family in the Samoas. They gather for the purpose of organizing events ranging from church inaugurations and funerals to weddings, bestowals of titles, etc. They are the capable hands that deftly move a family through its rigors.</p>
<p class="block_12" id="calibre_pb_4"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_003.vue?980ff7cc